import React from "react";

const styles = {
  PENDING: "bg-yellow-100 text-yellow-800",
  PAID: "bg-green-100 text-green-800",
  FAILED: "bg-red-100 text-red-800",
};

export default function PaymentStatusBadge({ status }) {
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${ styles[status] || "bg-gray-100 dark:bg-neutral-900 text-gray-800 dark:text-neutral-100" }`}
    >
      {status}
    </span>
  );
}
